import axios from "../../apiFc24";

export type FormationsAsList = {
  id: string;
  playerRoleIds: number[];
  positions: string[];
  label: string;
}[];

export type Formations = {
  [formationId: string]: {
    playerRoleIds: number[];
    positions: string[];
    label: string;
  };
};

export const getFormations = async () => {
  const res = await axios.get<FormationsAsList>("/formations");

  const formations: Formations = {};
  res.data.forEach((formation) => {
    formations[formation.id] = {
      playerRoleIds: formation.playerRoleIds,
      positions: formation.positions,
      label: formation.label,
    };
  });

  return formations;
};
